import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { WasteService } from '@services/list-waste/waste.service';

@Component({
  selector: 'app-list-waste',
  templateUrl: './list-waste.component.html',
  styleUrls: ['./list-waste.component.scss']
})
export class ListWasteComponent implements OnInit {



  displayedColumns: string[] = ['infraction_id', 'camera', 'video_stream'];



  constructor(

    private wasteService: WasteService

  ) { }

  ngOnInit(): void {

    this.getWaste();

  }
  private getWaste(): void {





  }
}
